// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reusable Add Money Modal Styling (ARM) */

.arm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.45) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 2000 !important;
  animation: armFadeIn 0.25s ease-out;
}

.arm-modal-container {
  background: #ffffff !important;
  border-radius: 24px !important;
  width: 92% !important;
  max-width: 580px !important; /* Increased width from 400px to 580px */
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
  border: 1px solid rgba(241, 245, 249, 0.8) !important;
  overflow: hidden !important;
  animation: armScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: flex !important;
  flex-direction: column !important;
}

@keyframes armFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes armScaleIn {
  from { transform: scale(0.95) translateY(15px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

.arm-modal-header {
  padding: 24px 28px 16px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border-bottom: 1px solid #f1f5f9 !important;
  background: #ffffff !important;
}

.arm-modal-title {
  margin: 0 !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
}

.arm-modal-header-actions {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

/* Offers Badge Button */
.arm-offers-badge-btn {
  background: linear-gradient(135deg, #ff7a00 0%, #ff5c00 100%) !important;
  border: none !important;
  color: white !important;
  padding: 8px 16px !important;
  border-radius: 50px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 4px 10px rgba(255, 122, 0, 0.25) !important;
}

.arm-offers-badge-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 14px rgba(255, 122, 0, 0.35) !important;
}

.arm-offers-badge-btn:active {
  transform: translateY(1px) !important;
}

.arm-modal-close-btn {
  background: #f8fafc !important;
  border: none !important;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #64748b !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.arm-modal-close-btn:hover {
  background: #e2e8f0 !important;
  color: #0f172a !important;
  transform: rotate(90deg) !important;
}

.arm-modal-body {
  padding: 24px 28px 24px !important;
  background: #ffffff !important;
}

/* Wallet Balance Banner */
.arm-wallet-balance-banner {
  background: #eef2ff !important; /* Soft indigo theme */
  border-radius: 16px !important;
  padding: 16px 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border: 1px solid rgba(224, 231, 255, 0.8) !important;
  margin-bottom: 20px !important;
}

.arm-balance-label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #4f46e5 !important;
}

.arm-balance-value {
  font-size: 22px !important;
  font-weight: 800 !important;
  color: #312e81 !important;
  margin-left: auto !important;
  margin-right: 12px !important;
  font-family: inherit !important;
}

.arm-balance-refresh-btn {
  background: #ffffff !important;
  border: 1px solid #cbd5e1 !important;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  color: #0284c7 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.arm-balance-refresh-btn:hover {
  background: #f8fafc !important;
  color: #0369a1 !important;
  border-color: #94a3b8 !important;
}

.arm-balance-refresh-btn:active {
  transform: scale(0.95) !important;
}

/* Payment Feedback Toast-style Banner */
.arm-payment-feedback-banner {
  padding: 12px 18px !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  margin-bottom: 20px !important;
  animation: armSlideDown 0.3s ease-out;
}

.arm-payment-feedback-banner.success {
  background: #ecfdf5 !important;
  color: #065f46 !important;
  border: 1px solid #a7f3d0 !important;
}

.arm-payment-feedback-banner.error {
  background: #fef2f2 !important;
  color: #991b1b !important;
  border: 1px solid #fca5a5 !important;
}

.arm-payment-feedback-banner.info {
  background: #eff6ff !important;
  color: #1e40af !important;
  border: 1px solid #bfdbfe !important;
}

@keyframes armSlideDown {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Alert Warning Info Box */
.arm-alert-info-box {
  background: #f8fafc !important;
  border-left: 4px solid #3b82f6 !important;
  padding: 14px 16px !important;
  border-radius: 12px !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 12px !important;
  margin-bottom: 24px !important;
}

.arm-alert-info-icon {
  color: #3b82f6 !important;
  font-size: 16px !important;
  margin-top: 2px !important;
}

.arm-alert-info-text {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #475569 !important;
  line-height: 1.5 !important;
  text-align: left !important;
}

.arm-alert-refresh-link {
  background: transparent !important;
  border: none !important;
  color: #2563eb !important;
  padding: 0 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  text-decoration: underline !important;
  display: inline !important;
  margin-left: 4px !important;
}

.arm-alert-refresh-link:hover {
  color: #1d4ed8 !important;
}

/* Core Two-Column Layout */
.arm-modal-core-layout {
  display: grid !important;
  grid-template-columns: 1.1fr 0.9fr !important; /* 2 Column grid on desktop */
  gap: 24px !important;
  margin-bottom: 24px !important;
  align-items: flex-start !important;
}

.arm-modal-left-column {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.arm-modal-right-column {
  display: flex !important;
  flex-direction: column !important;
}

/* Input Form Field */
.arm-input-form-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
}

.arm-input-amount-wrapper {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
}

.arm-input-currency-symbol {
  position: absolute !important;
  left: 20px !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #64748b !important;
  pointer-events: none !important;
}

.arm-amount-input-field {
  width: 100% !important;
  padding: 16px 20px 16px 44px !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 16px !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  background-color: #f8fafc !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box !important;
  letter-spacing: -0.01em !important;
}

.arm-amount-input-field:focus {
  outline: none !important;
  border-color: #8b5cf6 !important; /* Premium purple focus */
  background-color: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.15) !important;
}

.arm-amount-input-field.arm-input-error-state {
  border-color: #ef4444 !important;
  background-color: #fff5f5 !important;
}

.arm-amount-input-field.arm-input-error-state:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.15) !important;
}

.arm-input-error-label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #dc2626 !important;
  text-align: left !important;
}

/* Bonus Indicator Reward Card */
.arm-bonus-reward-card {
  background: #fef3c7 !important; /* Soft yellow */
  border-radius: 12px !important;
  padding: 10px 14px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  border: 1px solid #fde68a !important;
  animation: armPulseScale 1.5s infinite ease-in-out;
}

@keyframes armPulseScale {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

.arm-bonus-gift-icon {
  font-size: 18px !important;
}

.arm-bonus-gift-text {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #92400e !important;
  text-align: left !important;
}

/* Quick Chips Grid (Right Column) */
.arm-quick-chips-grid {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr) !important; /* 2x2 grid of chips */
  gap: 12px !important;
}

.arm-quick-chip-btn {
  background: #ffffff !important;
  border: 1.5px solid #e2e8f0 !important;
  color: #475569 !important;
  padding: 14px 12px !important;
  border-radius: 14px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02) !important;
}

.arm-quick-chip-btn:hover {
  background: #f8fafc !important;
  color: #0f172a !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
}

.arm-quick-chip-btn.arm-quick-chip-selected {
  background: #10b981 !important; /* Dudhiya green for selected state */
  color: #ffffff !important;
  border-color: #10b981 !important;
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.25) !important;
}

/* Pay CTAs Action Wrapper */
.arm-modal-action-wrapper {
  margin-top: 10px !important;
  display: flex !important;
  justify-content: center !important;
}

.arm-pay-submit-btn {
  width: 100% !important;
  max-width: 300px !important;
  padding: 11px 20px !important;
  border: none !important;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important; /* Indigo gradient */
  color: white !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 6px 12px -3px rgba(79, 70, 229, 0.3), 0 2px 4px -2px rgba(79, 70, 229, 0.1) !important;
}

.arm-pay-submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%) !important;
  box-shadow: 0 12px 18px -5px rgba(79, 70, 229, 0.4), 0 6px 6px -5px rgba(79, 70, 229, 0.2) !important;
  transform: translateY(-1px) !important;
}

.arm-pay-submit-btn:active:not(:disabled) {
  transform: translateY(1px) !important;
}

.arm-pay-submit-btn:disabled {
  background: #cbd5e1 !important;
  color: #94a3b8 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

/* Trouble support footer banner */
.arm-modal-footer-support {
  padding: 16px 28px !important;
  background-color: #f8fafc !important;
  border-top: 1px solid #f1f5f9 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.arm-support-prompt-text {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #64748b !important;
  text-align: left !important;
}

.arm-support-contact-btn {
  background: #1e3a8a !important; /* Dark blue */
  border: none !important;
  color: white !important;
  padding: 8px 16px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  transition: all 0.2s ease !important;
}

.arm-support-contact-btn:hover {
  background: #172554 !important;
  transform: translateY(-1px) !important;
}

.arm-support-contact-btn:active {
  transform: translateY(1px) !important;
}

/* ==========================================================================
   Nested Modals Styles (Offers & Support overlay checkouts)
   ========================================================================== */

.arm-nested-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.4) !important;
  backdrop-filter: blur(4px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 2100 !important; /* Stacks above the AddMoney modal overlay */
  animation: armFadeIn 0.2s ease-out;
}

.arm-nested-modal-card {
  background: #ffffff !important;
  border-radius: 20px !important;
  width: 90% !important;
  max-width: 440px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  overflow: hidden !important;
  animation: armScaleIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.arm-nested-modal-header {
  padding: 20px 24px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.arm-nested-modal-header h3 {
  margin: 0 !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.arm-nested-modal-close {
  background: #f1f5f9 !important;
  border: none !important;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #475569 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.arm-nested-modal-close:hover {
  background: #cbd5e1 !important;
  color: #0f172a !important;
}

.arm-nested-modal-body {
  padding: 24px !important;
}

/* Nested support channels list */
.arm-support-channels-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.arm-support-channel {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  padding: 16px 20px !important;
  border-radius: 16px !important;
  text-decoration: none !important;
  transition: all 0.2s ease !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

.arm-support-channel.whatsapp-support {
  border-color: #bbf7d0 !important;
}

.arm-support-channel.whatsapp-channel {
  background: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
  color: #15803d !important;
}

.arm-support-channel.whatsapp-channel:hover {
  background: #dcfce7 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 6px -1px rgba(22, 163, 74, 0.1) !important;
}

.arm-support-channel.call-channel {
  background: #eff6ff !important;
  border-color: #bfdbfe !important;
  color: #1d4ed8 !important;
}

.arm-support-channel.call-channel:hover {
  background: #dbeafe !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1) !important;
}

.arm-channel-icon-bg {
  width: 44px !important;
  height: 44px !important;
  border-radius: 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 20px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.arm-channel-info {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  text-align: left !important;
}

.arm-channel-info h4 {
  margin: 0 !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.arm-channel-detail {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #64748b !important;
}

/* Nested Offers Title Block */
.arm-offers-title-block {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  text-align: left !important;
}

.arm-offers-title-icon {
  font-size: 28px !important;
  color: #f59e0b !important;
}

.arm-offers-subtitle {
  margin: 4px 0 0 0 !important;
  font-size: 12px !important;
  color: #64748b !important;
  font-weight: 500 !important;
}

/* Offers lists items styling */
.arm-offers-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  margin-bottom: 24px !important;
}

.arm-offer-item {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  padding: 16px 20px !important;
  border-radius: 16px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
}

.arm-offer-item.starter-offer {
  border-left: 5px solid #f59e0b !important;
}

.arm-offer-item.premium-offer {
  border-left: 5px solid #10b981 !important;
}

.arm-offer-badge {
  background: #ffffff !important;
  border: 1px solid #cbd5e1 !important;
  padding: 6px 10px !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  white-space: nowrap !important;
}

.arm-offer-item.starter-offer .arm-offer-badge {
  border-color: #fde68a !important;
  background: #fffbeb !important;
  color: #d97706 !important;
}

.arm-offer-item.premium-offer .arm-offer-badge {
  border-color: #a7f3d0 !important;
  background: #ecfdf5 !important;
  color: #059669 !important;
}

.arm-offer-details {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  text-align: left !important;
}

.arm-offer-details h4 {
  margin: 0 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.arm-offer-details p {
  margin: 0 !important;
  font-size: 12px !important;
  color: #64748b !important;
  font-weight: 500 !important;
}

.arm-offers-support-footer {
  border-top: 1px solid #f1f5f9 !important;
  padding-top: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.arm-offers-support-footer p {
  margin: 0 !important;
  font-size: 13px !important;
  color: #64748b !important;
  font-weight: 500 !important;
}

.arm-offers-contact-btn {
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  color: #475569 !important;
  padding: 8px 16px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  transition: all 0.2s ease !important;
}

.arm-offers-contact-btn:hover {
  background: #e2e8f0 !important;
  color: #0f172a !important;
}

/* ==========================================================================
   Responsive Queries
   ========================================================================== */

@media (max-width: 600px) {
  .arm-modal-container {
    max-height: 94vh !important;
    width: 94% !important;
    border-radius: 20px !important;
  }

  .arm-modal-header {
    padding: 12px 18px !important;
  }

  .arm-modal-title {
    font-size: 18px !important;
  }

  .arm-offers-badge-btn {
    padding: 6px 12px !important;
    font-size: 12px !important;
  }

  .arm-modal-close-btn {
    width: 32px !important;
    height: 32px !important;
  }

  .arm-modal-body {
    padding: 14px 18px !important;
    overflow-y: auto !important;
    max-height: calc(94vh - 120px) !important;
  }

  .arm-wallet-balance-banner {
    padding: 10px 14px !important;
    margin-bottom: 12px !important;
    border-radius: 12px !important;
  }

  .arm-balance-label {
    font-size: 12px !important;
  }

  .arm-balance-value {
    font-size: 18px !important;
    margin-right: 8px !important;
  }

  .arm-balance-refresh-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .arm-payment-feedback-banner {
    padding: 10px 14px !important;
    font-size: 12px !important;
    margin-bottom: 12px !important;
  }

  .arm-alert-info-box {
    padding: 10px 12px !important;
    margin-bottom: 12px !important;
    border-radius: 10px !important;
    gap: 8px !important;
  }

  .arm-alert-info-icon {
    font-size: 14px !important;
  }

  .arm-alert-info-text {
    font-size: 12px !important;
  }

  .arm-alert-refresh-link {
    font-size: 12px !important;
  }

  .arm-modal-core-layout {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
    margin-bottom: 16px !important;
  }

  .arm-amount-input-field {
    font-size: 20px !important;
    padding: 12px 16px 12px 38px !important;
    border-radius: 12px !important;
  }

  .arm-input-currency-symbol {
    font-size: 18px !important;
    left: 16px !important;
  }

  .arm-bonus-reward-card {
    padding: 8px 12px !important;
    border-radius: 10px !important;
    gap: 8px !important;
  }

  .arm-bonus-gift-icon {
    font-size: 16px !important;
  }

  .arm-bonus-gift-text {
    font-size: 12px !important;
  }

  .arm-quick-chips-grid {
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 6px !important;
  }

  .arm-quick-chip-btn {
    padding: 10px 2px !important;
    font-size: 13px !important;
    border-radius: 10px !important;
  }

  .arm-pay-submit-btn {
    padding: 12px 20px !important;
    font-size: 15px !important;
    border-radius: 12px !important;
  }

  .arm-modal-footer-support {
    padding: 12px 18px !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .arm-support-prompt-text {
    font-size: 12px !important;
  }

  .arm-support-contact-btn {
    padding: 6px 12px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
  }

  /* Nested Card Mobile styling */
  .arm-nested-modal-card {
    width: 94% !important;
    border-radius: 16px !important;
  }

  .arm-nested-modal-header {
    padding: 14px 18px !important;
  }

  .arm-nested-modal-header h3 {
    font-size: 16px !important;
  }

  .arm-nested-modal-body {
    padding: 16px 18px !important;
  }

  .arm-support-channels-list {
    gap: 12px !important;
  }

  .arm-support-channel {
    padding: 12px 16px !important;
    border-radius: 12px !important;
    gap: 12px !important;
  }

  .arm-channel-icon-bg {
    width: 36px !important;
    height: 36px !important;
    font-size: 16px !important;
    border-radius: 8px !important;
  }

  .arm-channel-info h4 {
    font-size: 14px !important;
  }

  .arm-channel-detail {
    font-size: 12px !important;
  }

  .arm-offers-list {
    gap: 12px !important;
    margin-bottom: 16px !important;
  }

  .arm-offer-item {
    padding: 12px 16px !important;
    border-radius: 12px !important;
    gap: 12px !important;
  }

  .arm-offer-badge {
    padding: 4px 8px !important;
    font-size: 11px !important;
  }

  .arm-offer-details h4 {
    font-size: 13px !important;
  }

  .arm-offer-details p {
    font-size: 11px !important;
  }

  .arm-offers-support-footer {
    padding-top: 12px !important;
  }

  .arm-offers-support-footer p {
    font-size: 12px !important;
  }

  .arm-offers-contact-btn {
    padding: 6px 12px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AddMoneyModal.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,qCAAqC;EACrC,6CAA6C;EAC7C,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B,EAAE,wCAAwC;EACrE,+DAA+D;EAC/D,qDAAqD;EACrD,2BAA2B;EAC3B,4DAA4D;EAC5D,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B,EAAE,sBAAsB;EACtD,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,6CAA6C,EAAE,6BAA6B;EAC5E,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC,EAAE,yBAAyB;EAC3D,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,8BAA8B,EAAE,gBAAgB;EAChD,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;EACxB,gDAAgD,EAAE,sBAAsB;EACxE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B,EAAE,qCAAqC;EACrE,yBAAyB;EACzB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wEAAwE,EAAE,oBAAoB;EAC9F,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oGAAoG;AACtG;;AAEA;EACE,wEAAwE;EACxE,qGAAqG;EACrG,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B,EAAE,cAAc;EAC9C,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kDAAkD;EAClD,qCAAqC;EACrC,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB,EAAE,4CAA4C;EACtE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,gGAAgG;EAChG,qDAAqD;EACrD,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF","sourcesContent":["/* Reusable Add Money Modal Styling (ARM) */\n\n.arm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.45) !important;\n  backdrop-filter: blur(8px) !important;\n  -webkit-backdrop-filter: blur(8px) !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 2000 !important;\n  animation: armFadeIn 0.25s ease-out;\n}\n\n.arm-modal-container {\n  background: #ffffff !important;\n  border-radius: 24px !important;\n  width: 92% !important;\n  max-width: 580px !important; /* Increased width from 400px to 580px */\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;\n  border: 1px solid rgba(241, 245, 249, 0.8) !important;\n  overflow: hidden !important;\n  animation: armScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n@keyframes armFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes armScaleIn {\n  from { transform: scale(0.95) translateY(15px); opacity: 0; }\n  to { transform: scale(1) translateY(0); opacity: 1; }\n}\n\n.arm-modal-header {\n  padding: 24px 28px 16px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n  background: #ffffff !important;\n}\n\n.arm-modal-title {\n  margin: 0 !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  letter-spacing: -0.02em !important;\n}\n\n.arm-modal-header-actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n}\n\n/* Offers Badge Button */\n.arm-offers-badge-btn {\n  background: linear-gradient(135deg, #ff7a00 0%, #ff5c00 100%) !important;\n  border: none !important;\n  color: white !important;\n  padding: 8px 16px !important;\n  border-radius: 50px !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 4px 10px rgba(255, 122, 0, 0.25) !important;\n}\n\n.arm-offers-badge-btn:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 6px 14px rgba(255, 122, 0, 0.35) !important;\n}\n\n.arm-offers-badge-btn:active {\n  transform: translateY(1px) !important;\n}\n\n.arm-modal-close-btn {\n  background: #f8fafc !important;\n  border: none !important;\n  width: 38px !important;\n  height: 38px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #64748b !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.arm-modal-close-btn:hover {\n  background: #e2e8f0 !important;\n  color: #0f172a !important;\n  transform: rotate(90deg) !important;\n}\n\n.arm-modal-body {\n  padding: 24px 28px 24px !important;\n  background: #ffffff !important;\n}\n\n/* Wallet Balance Banner */\n.arm-wallet-balance-banner {\n  background: #eef2ff !important; /* Soft indigo theme */\n  border-radius: 16px !important;\n  padding: 16px 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  border: 1px solid rgba(224, 231, 255, 0.8) !important;\n  margin-bottom: 20px !important;\n}\n\n.arm-balance-label {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #4f46e5 !important;\n}\n\n.arm-balance-value {\n  font-size: 22px !important;\n  font-weight: 800 !important;\n  color: #312e81 !important;\n  margin-left: auto !important;\n  margin-right: 12px !important;\n  font-family: inherit !important;\n}\n\n.arm-balance-refresh-btn {\n  background: #ffffff !important;\n  border: 1px solid #cbd5e1 !important;\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  color: #0284c7 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;\n}\n\n.arm-balance-refresh-btn:hover {\n  background: #f8fafc !important;\n  color: #0369a1 !important;\n  border-color: #94a3b8 !important;\n}\n\n.arm-balance-refresh-btn:active {\n  transform: scale(0.95) !important;\n}\n\n/* Payment Feedback Toast-style Banner */\n.arm-payment-feedback-banner {\n  padding: 12px 18px !important;\n  border-radius: 12px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  margin-bottom: 20px !important;\n  animation: armSlideDown 0.3s ease-out;\n}\n\n.arm-payment-feedback-banner.success {\n  background: #ecfdf5 !important;\n  color: #065f46 !important;\n  border: 1px solid #a7f3d0 !important;\n}\n\n.arm-payment-feedback-banner.error {\n  background: #fef2f2 !important;\n  color: #991b1b !important;\n  border: 1px solid #fca5a5 !important;\n}\n\n.arm-payment-feedback-banner.info {\n  background: #eff6ff !important;\n  color: #1e40af !important;\n  border: 1px solid #bfdbfe !important;\n}\n\n@keyframes armSlideDown {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Alert Warning Info Box */\n.arm-alert-info-box {\n  background: #f8fafc !important;\n  border-left: 4px solid #3b82f6 !important;\n  padding: 14px 16px !important;\n  border-radius: 12px !important;\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 12px !important;\n  margin-bottom: 24px !important;\n}\n\n.arm-alert-info-icon {\n  color: #3b82f6 !important;\n  font-size: 16px !important;\n  margin-top: 2px !important;\n}\n\n.arm-alert-info-text {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #475569 !important;\n  line-height: 1.5 !important;\n  text-align: left !important;\n}\n\n.arm-alert-refresh-link {\n  background: transparent !important;\n  border: none !important;\n  color: #2563eb !important;\n  padding: 0 !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  text-decoration: underline !important;\n  display: inline !important;\n  margin-left: 4px !important;\n}\n\n.arm-alert-refresh-link:hover {\n  color: #1d4ed8 !important;\n}\n\n/* Core Two-Column Layout */\n.arm-modal-core-layout {\n  display: grid !important;\n  grid-template-columns: 1.1fr 0.9fr !important; /* 2 Column grid on desktop */\n  gap: 24px !important;\n  margin-bottom: 24px !important;\n  align-items: flex-start !important;\n}\n\n.arm-modal-left-column {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n}\n\n.arm-modal-right-column {\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n/* Input Form Field */\n.arm-input-form-group {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n}\n\n.arm-input-amount-wrapper {\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.arm-input-currency-symbol {\n  position: absolute !important;\n  left: 20px !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  color: #64748b !important;\n  pointer-events: none !important;\n}\n\n.arm-amount-input-field {\n  width: 100% !important;\n  padding: 16px 20px 16px 44px !important;\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 16px !important;\n  font-size: 24px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  background-color: #f8fafc !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box !important;\n  letter-spacing: -0.01em !important;\n}\n\n.arm-amount-input-field:focus {\n  outline: none !important;\n  border-color: #8b5cf6 !important; /* Premium purple focus */\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.15) !important;\n}\n\n.arm-amount-input-field.arm-input-error-state {\n  border-color: #ef4444 !important;\n  background-color: #fff5f5 !important;\n}\n\n.arm-amount-input-field.arm-input-error-state:focus {\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.15) !important;\n}\n\n.arm-input-error-label {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #dc2626 !important;\n  text-align: left !important;\n}\n\n/* Bonus Indicator Reward Card */\n.arm-bonus-reward-card {\n  background: #fef3c7 !important; /* Soft yellow */\n  border-radius: 12px !important;\n  padding: 10px 14px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  border: 1px solid #fde68a !important;\n  animation: armPulseScale 1.5s infinite ease-in-out;\n}\n\n@keyframes armPulseScale {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.02); }\n}\n\n.arm-bonus-gift-icon {\n  font-size: 18px !important;\n}\n\n.arm-bonus-gift-text {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #92400e !important;\n  text-align: left !important;\n}\n\n/* Quick Chips Grid (Right Column) */\n.arm-quick-chips-grid {\n  display: grid !important;\n  grid-template-columns: repeat(2, 1fr) !important; /* 2x2 grid of chips */\n  gap: 12px !important;\n}\n\n.arm-quick-chip-btn {\n  background: #ffffff !important;\n  border: 1.5px solid #e2e8f0 !important;\n  color: #475569 !important;\n  padding: 14px 12px !important;\n  border-radius: 14px !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02) !important;\n}\n\n.arm-quick-chip-btn:hover {\n  background: #f8fafc !important;\n  color: #0f172a !important;\n  border-color: #cbd5e1 !important;\n  transform: translateY(-1px) !important;\n}\n\n.arm-quick-chip-btn.arm-quick-chip-selected {\n  background: #10b981 !important; /* Dudhiya green for selected state */\n  color: #ffffff !important;\n  border-color: #10b981 !important;\n  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.25) !important;\n}\n\n/* Pay CTAs Action Wrapper */\n.arm-modal-action-wrapper {\n  margin-top: 10px !important;\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.arm-pay-submit-btn {\n  width: 100% !important;\n  max-width: 300px !important;\n  padding: 11px 20px !important;\n  border: none !important;\n  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important; /* Indigo gradient */\n  color: white !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 6px 12px -3px rgba(79, 70, 229, 0.3), 0 2px 4px -2px rgba(79, 70, 229, 0.1) !important;\n}\n\n.arm-pay-submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%) !important;\n  box-shadow: 0 12px 18px -5px rgba(79, 70, 229, 0.4), 0 6px 6px -5px rgba(79, 70, 229, 0.2) !important;\n  transform: translateY(-1px) !important;\n}\n\n.arm-pay-submit-btn:active:not(:disabled) {\n  transform: translateY(1px) !important;\n}\n\n.arm-pay-submit-btn:disabled {\n  background: #cbd5e1 !important;\n  color: #94a3b8 !important;\n  cursor: not-allowed !important;\n  box-shadow: none !important;\n}\n\n/* Trouble support footer banner */\n.arm-modal-footer-support {\n  padding: 16px 28px !important;\n  background-color: #f8fafc !important;\n  border-top: 1px solid #f1f5f9 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n}\n\n.arm-support-prompt-text {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #64748b !important;\n  text-align: left !important;\n}\n\n.arm-support-contact-btn {\n  background: #1e3a8a !important; /* Dark blue */\n  border: none !important;\n  color: white !important;\n  padding: 8px 16px !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  transition: all 0.2s ease !important;\n}\n\n.arm-support-contact-btn:hover {\n  background: #172554 !important;\n  transform: translateY(-1px) !important;\n}\n\n.arm-support-contact-btn:active {\n  transform: translateY(1px) !important;\n}\n\n/* ==========================================================================\n   Nested Modals Styles (Offers & Support overlay checkouts)\n   ========================================================================== */\n\n.arm-nested-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.4) !important;\n  backdrop-filter: blur(4px) !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 2100 !important; /* Stacks above the AddMoney modal overlay */\n  animation: armFadeIn 0.2s ease-out;\n}\n\n.arm-nested-modal-card {\n  background: #ffffff !important;\n  border-radius: 20px !important;\n  width: 90% !important;\n  max-width: 440px !important;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid rgba(226, 232, 240, 0.8) !important;\n  overflow: hidden !important;\n  animation: armScaleIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.arm-nested-modal-header {\n  padding: 20px 24px !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n}\n\n.arm-nested-modal-header h3 {\n  margin: 0 !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n}\n\n.arm-nested-modal-close {\n  background: #f1f5f9 !important;\n  border: none !important;\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #475569 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.arm-nested-modal-close:hover {\n  background: #cbd5e1 !important;\n  color: #0f172a !important;\n}\n\n.arm-nested-modal-body {\n  padding: 24px !important;\n}\n\n/* Nested support channels list */\n.arm-support-channels-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n}\n\n.arm-support-channel {\n  display: flex !important;\n  align-items: center !important;\n  gap: 16px !important;\n  padding: 16px 20px !important;\n  border-radius: 16px !important;\n  text-decoration: none !important;\n  transition: all 0.2s ease !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;\n}\n\n.arm-support-channel.whatsapp-support {\n  border-color: #bbf7d0 !important;\n}\n\n.arm-support-channel.whatsapp-channel {\n  background: #f0fdf4 !important;\n  border-color: #bbf7d0 !important;\n  color: #15803d !important;\n}\n\n.arm-support-channel.whatsapp-channel:hover {\n  background: #dcfce7 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 6px -1px rgba(22, 163, 74, 0.1) !important;\n}\n\n.arm-support-channel.call-channel {\n  background: #eff6ff !important;\n  border-color: #bfdbfe !important;\n  color: #1d4ed8 !important;\n}\n\n.arm-support-channel.call-channel:hover {\n  background: #dbeafe !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1) !important;\n}\n\n.arm-channel-icon-bg {\n  width: 44px !important;\n  height: 44px !important;\n  border-radius: 12px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 20px !important;\n  background: #ffffff !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;\n}\n\n.arm-channel-info {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n  text-align: left !important;\n}\n\n.arm-channel-info h4 {\n  margin: 0 !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n}\n\n.arm-channel-detail {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #64748b !important;\n}\n\n/* Nested Offers Title Block */\n.arm-offers-title-block {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  text-align: left !important;\n}\n\n.arm-offers-title-icon {\n  font-size: 28px !important;\n  color: #f59e0b !important;\n}\n\n.arm-offers-subtitle {\n  margin: 4px 0 0 0 !important;\n  font-size: 12px !important;\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n/* Offers lists items styling */\n.arm-offers-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n  margin-bottom: 24px !important;\n}\n\n.arm-offer-item {\n  display: flex !important;\n  align-items: center !important;\n  gap: 16px !important;\n  padding: 16px 20px !important;\n  border-radius: 16px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #f8fafc !important;\n}\n\n.arm-offer-item.starter-offer {\n  border-left: 5px solid #f59e0b !important;\n}\n\n.arm-offer-item.premium-offer {\n  border-left: 5px solid #10b981 !important;\n}\n\n.arm-offer-badge {\n  background: #ffffff !important;\n  border: 1px solid #cbd5e1 !important;\n  padding: 6px 10px !important;\n  border-radius: 8px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  white-space: nowrap !important;\n}\n\n.arm-offer-item.starter-offer .arm-offer-badge {\n  border-color: #fde68a !important;\n  background: #fffbeb !important;\n  color: #d97706 !important;\n}\n\n.arm-offer-item.premium-offer .arm-offer-badge {\n  border-color: #a7f3d0 !important;\n  background: #ecfdf5 !important;\n  color: #059669 !important;\n}\n\n.arm-offer-details {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n  text-align: left !important;\n}\n\n.arm-offer-details h4 {\n  margin: 0 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n}\n\n.arm-offer-details p {\n  margin: 0 !important;\n  font-size: 12px !important;\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n.arm-offers-support-footer {\n  border-top: 1px solid #f1f5f9 !important;\n  padding-top: 16px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n}\n\n.arm-offers-support-footer p {\n  margin: 0 !important;\n  font-size: 13px !important;\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n.arm-offers-contact-btn {\n  background: #f1f5f9 !important;\n  border: 1px solid #e2e8f0 !important;\n  color: #475569 !important;\n  padding: 8px 16px !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  transition: all 0.2s ease !important;\n}\n\n.arm-offers-contact-btn:hover {\n  background: #e2e8f0 !important;\n  color: #0f172a !important;\n}\n\n/* ==========================================================================\n   Responsive Queries\n   ========================================================================== */\n\n@media (max-width: 600px) {\n  .arm-modal-container {\n    max-height: 94vh !important;\n    width: 94% !important;\n    border-radius: 20px !important;\n  }\n\n  .arm-modal-header {\n    padding: 12px 18px !important;\n  }\n\n  .arm-modal-title {\n    font-size: 18px !important;\n  }\n\n  .arm-offers-badge-btn {\n    padding: 6px 12px !important;\n    font-size: 12px !important;\n  }\n\n  .arm-modal-close-btn {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .arm-modal-body {\n    padding: 14px 18px !important;\n    overflow-y: auto !important;\n    max-height: calc(94vh - 120px) !important;\n  }\n\n  .arm-wallet-balance-banner {\n    padding: 10px 14px !important;\n    margin-bottom: 12px !important;\n    border-radius: 12px !important;\n  }\n\n  .arm-balance-label {\n    font-size: 12px !important;\n  }\n\n  .arm-balance-value {\n    font-size: 18px !important;\n    margin-right: 8px !important;\n  }\n\n  .arm-balance-refresh-btn {\n    width: 28px !important;\n    height: 28px !important;\n  }\n\n  .arm-payment-feedback-banner {\n    padding: 10px 14px !important;\n    font-size: 12px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .arm-alert-info-box {\n    padding: 10px 12px !important;\n    margin-bottom: 12px !important;\n    border-radius: 10px !important;\n    gap: 8px !important;\n  }\n\n  .arm-alert-info-icon {\n    font-size: 14px !important;\n  }\n\n  .arm-alert-info-text {\n    font-size: 12px !important;\n  }\n\n  .arm-alert-refresh-link {\n    font-size: 12px !important;\n  }\n\n  .arm-modal-core-layout {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n    margin-bottom: 16px !important;\n  }\n\n  .arm-amount-input-field {\n    font-size: 20px !important;\n    padding: 12px 16px 12px 38px !important;\n    border-radius: 12px !important;\n  }\n\n  .arm-input-currency-symbol {\n    font-size: 18px !important;\n    left: 16px !important;\n  }\n\n  .arm-bonus-reward-card {\n    padding: 8px 12px !important;\n    border-radius: 10px !important;\n    gap: 8px !important;\n  }\n\n  .arm-bonus-gift-icon {\n    font-size: 16px !important;\n  }\n\n  .arm-bonus-gift-text {\n    font-size: 12px !important;\n  }\n\n  .arm-quick-chips-grid {\n    grid-template-columns: repeat(4, 1fr) !important;\n    gap: 6px !important;\n  }\n\n  .arm-quick-chip-btn {\n    padding: 10px 2px !important;\n    font-size: 13px !important;\n    border-radius: 10px !important;\n  }\n\n  .arm-pay-submit-btn {\n    padding: 12px 20px !important;\n    font-size: 15px !important;\n    border-radius: 12px !important;\n  }\n\n  .arm-modal-footer-support {\n    padding: 12px 18px !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    gap: 10px !important;\n  }\n\n  .arm-support-prompt-text {\n    font-size: 12px !important;\n  }\n\n  .arm-support-contact-btn {\n    padding: 6px 12px !important;\n    font-size: 12px !important;\n    border-radius: 8px !important;\n  }\n\n  /* Nested Card Mobile styling */\n  .arm-nested-modal-card {\n    width: 94% !important;\n    border-radius: 16px !important;\n  }\n\n  .arm-nested-modal-header {\n    padding: 14px 18px !important;\n  }\n\n  .arm-nested-modal-header h3 {\n    font-size: 16px !important;\n  }\n\n  .arm-nested-modal-body {\n    padding: 16px 18px !important;\n  }\n\n  .arm-support-channels-list {\n    gap: 12px !important;\n  }\n\n  .arm-support-channel {\n    padding: 12px 16px !important;\n    border-radius: 12px !important;\n    gap: 12px !important;\n  }\n\n  .arm-channel-icon-bg {\n    width: 36px !important;\n    height: 36px !important;\n    font-size: 16px !important;\n    border-radius: 8px !important;\n  }\n\n  .arm-channel-info h4 {\n    font-size: 14px !important;\n  }\n\n  .arm-channel-detail {\n    font-size: 12px !important;\n  }\n\n  .arm-offers-list {\n    gap: 12px !important;\n    margin-bottom: 16px !important;\n  }\n\n  .arm-offer-item {\n    padding: 12px 16px !important;\n    border-radius: 12px !important;\n    gap: 12px !important;\n  }\n\n  .arm-offer-badge {\n    padding: 4px 8px !important;\n    font-size: 11px !important;\n  }\n\n  .arm-offer-details h4 {\n    font-size: 13px !important;\n  }\n\n  .arm-offer-details p {\n    font-size: 11px !important;\n  }\n\n  .arm-offers-support-footer {\n    padding-top: 12px !important;\n  }\n\n  .arm-offers-support-footer p {\n    font-size: 12px !important;\n  }\n\n  .arm-offers-contact-btn {\n    padding: 6px 12px !important;\n    font-size: 12px !important;\n    border-radius: 8px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
